import { doc, setDoc } from "@firebase/firestore";
import { db } from "../firebase";

export const getSnapshotDocument = (doc) => ({ ...doc.data(), id: doc.id });

export const patchDoc = async ({ collection, documentId, data }) => {
  return await setDoc(doc(db, collection, documentId), data, { merge: true });
};
